import { TUser } from './types';

// 用以存储用户信息
export default <TUser>{
  name: '',
  time: '',
  userId: 0,
  uniqueId: '',
  idCardNum: '',
  mobile: '',
  hasAyhContract: false,
  isStudent: false,
  isIdCardExpired: false,
  alipayBound: false,
  isRealName: false,
  hasTransPwd: false,
  loginType: 0,
  refusePeriod: false,
};
